export default function FloatingCTA() {
  return (
    <a
      href="#contact"
      className="fixed bottom-20 right-5 z-40 bg-pink-500 hover:bg-pink-600 text-white px-5 py-3 rounded-full shadow-xl hover:scale-105 transition"
    >
      Book Now 🎉
    </a>
  );
}
